<template>
    <div class="">
        <div class="">
            <label class="">说明</label>
        </div>
        <div class="" style="width: 90%">
            <el-input class="textarea-value" type="textarea" v-model="desc"></el-input>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    export default{
        name: 'swb-price-apply',
        desc: '申请页面',
        data: function () {
            return {
                desc: null,
            }
        },
        created: function () {
        },
        methods: {
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.applyDesc = self.desc;
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceReply/PriceApply.vue